import { render } from "./RecordForm.vue?vue&type=template&id=37d3ab8c"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"

import "./RecordForm.vue?vue&type=style&index=0&id=37d3ab8c&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__